import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "elem-keyboard-box" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<ul class=\"numbers\"><li><a class=\"key c192\"><b>~</b><span>`</span></a></li><li><a class=\"key c49\"><b>!</b><span>1</span></a></li><li><a class=\"key c50\"><b>@</b><span>2</span></a></li><li><a class=\"key c51\"><b>#</b><span>3</span></a></li><li><a class=\"key c52\"><b>$</b><span>4</span></a></li><li><a class=\"key c53\"><b>%</b><span>5</span></a></li><li><a class=\"key c54\"><b>^</b><span>6</span></a></li><li><a class=\"key c55\"><b>&amp;</b><span>7</span></a></li><li><a class=\"key c56\"><b>*</b><span>8</span></a></li><li><a class=\"key c57\"><b>(</b><span>9</span></a></li><li><a class=\"key c48\"><b>)</b><span>0</span></a></li><li><a class=\"key c189 alt\"><b>_</b><span>-</span></a></li><li><a class=\"key c187\"><b>+</b><span>=</span></a></li><li><a class=\"key c46 delete\"><span>Delete</span></a></li></ul>", 1)
const _hoisted_3 = { class: "qwerty" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { class: "key c9 tab" }, [
    /*#__PURE__*/_createElementVNode("span", null, "tab")
  ])
], -1)
const _hoisted_5 = ["data-code", "onClick", "innerHTML"]
const _hoisted_6 = { class: "asdfg" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { class: "key c20 alt caps" }, [
    /*#__PURE__*/_createElementVNode("b"),
    /*#__PURE__*/_createElementVNode("span", null, "caps lock")
  ])
], -1)
const _hoisted_8 = ["data-code", "onClick", "innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { class: "key c13 alt enter" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Enter")
  ])
], -1)
const _hoisted_10 = { class: "zxcvb" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { class: "key c16 shiftleft" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Shift")
  ])
], -1)
const _hoisted_12 = ["data-code", "onClick", "innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { class: "key c16 shiftright" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Shift")
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<ul class=\"bottomrow\"><li><a class=\"key fn\"><span>fn</span></a></li><li><a class=\"key c17 control\"><span>control</span></a></li><li><a class=\"key option optionleft\"><span>option</span></a></li><li><a class=\"key command commandleft\"><span>command</span></a></li><li><a class=\"key c32 spacebar\"></a></li><li><a class=\"key command commandright\"><span>command</span></a></li><li><a class=\"key option optionright\"><span>option</span></a></li><ol><li><a class=\"key c37 left\"><span>◀</span></a></li><li><a class=\"key c38 up\"><span>▲</span></a><a class=\"key c40 down\"><span>▼</span></a></li><li><a class=\"key c39 right\"><span>▶</span></a></li></ol></ul>", 1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "static/icon/close.svg",
  alt: ""
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "change-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "键码:", -1)
const _hoisted_19 = { class: "input" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "change-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "键值:", -1)
const _hoisted_23 = { class: "input" }
const _hoisted_24 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_input_object = _resolveComponent("elem-input-object")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_elem_input_object, {
      name: _ctx.name,
      title: _ctx.title,
      required: _ctx.required,
      getValue: _ctx.getValue
    }, null, 8, ["name", "title", "required", "getValue"]),
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.qwe, (item, idx) => {
        return (_openBlock(), _createElementBlock("li", { key: idx }, [
          _createElementVNode("a", {
            class: _normalizeClass(["key center", item.isAlt ? 'alt' : '']),
            "data-code": item.code,
            onClick: _withModifiers(($event: any) => (_ctx.onClickChangeKey($event, 'qwe', idx)), ["stop"]),
            innerHTML: item.key
          }, null, 10, _hoisted_5)
        ]))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_6, [
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.asd, (item, idx) => {
        return (_openBlock(), _createElementBlock("li", { key: idx }, [
          _createElementVNode("a", {
            class: _normalizeClass(["key center", item.isAlt ? 'alt' : '']),
            "data-code": item.code,
            onClick: _withModifiers(($event: any) => (_ctx.onClickChangeKey($event, 'asd', idx)), ["stop"]),
            innerHTML: item.key
          }, null, 10, _hoisted_8)
        ]))
      }), 128)),
      _hoisted_9
    ]),
    _createElementVNode("ul", _hoisted_10, [
      _hoisted_11,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.zxc, (item, idx) => {
        return (_openBlock(), _createElementBlock("li", { key: idx }, [
          _createElementVNode("a", {
            class: _normalizeClass(["key center", item.isAlt ? 'alt' : '']),
            "data-code": item.code,
            onClick: _withModifiers(($event: any) => (_ctx.onClickChangeKey($event, 'zxc', idx)), ["stop"]),
            innerHTML: item.key
          }, null, 10, _hoisted_12)
        ]))
      }), 128)),
      _hoisted_13
    ]),
    _hoisted_14,
    (_ctx.changeKeyData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "change-box",
          style: _normalizeStyle({ top: _ctx.changeKeyData.y - 120 + 'px', left: _ctx.changeKeyData.x - 95 + 'px' })
        }, [
          _createElementVNode("div", {
            class: "close-box",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeKeyData = null))
          }, _hoisted_16),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("input", {
                autofocus: "",
                value: _ctx.changeKeyData.keyboard.code,
                type: "number",
                placeholder: "输入键码",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeCode($event, _ctx.changeKeyData))),
                onkeydown: "if (event.keyCode === 13) { return false }"
              }, null, 40, _hoisted_20)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("input", {
                value: _ctx.changeKeyData.keyboard.key,
                placeholder: "输入键值",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeKey($event, _ctx.changeKeyData))),
                onkeydown: "if (event.keyCode === 13) { this.value+= '<br>'; return false }"
              }, null, 40, _hoisted_24)
            ])
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}